/**
 * Onboarding Welcome 动效常量（GSAP masterTimeline）
 * @see Figma 88215:37171 · accent 渐变 42903:14332
 */

export const ONBOARDING_WELCOME_ANIM = {
  staggerMs: 120,
  drawerEnterDelayMs: 300,
  slideY: 8,
  textDurationMs: 400,
  counterDurationMs: 750,
  /** GSAP `-= durationVal * 1.2` */
  counterLeadMs: 480,
  accentFadeDurationMs: 500,
  /** gradient `"-= 0.35"` */
  accentOverlapMs: 350,
  buttonDurationMs: 600,
  /** main-action `"-= 0.25"` */
  buttonOverlapMs: 250,
} as const;

export const getTextCascadeEndMs = (chunkCount: number): number =>
  (chunkCount - 1) * ONBOARDING_WELCOME_ANIM.staggerMs +
  ONBOARDING_WELCOME_ANIM.textDurationMs;

export const getCounterStartMs = (chunkCount: number): number =>
  getTextCascadeEndMs(chunkCount) - ONBOARDING_WELCOME_ANIM.counterLeadMs;

export const getAccentFadeStartMs = (chunkCount: number): number =>
  getCounterStartMs(chunkCount) +
  ONBOARDING_WELCOME_ANIM.counterDurationMs -
  ONBOARDING_WELCOME_ANIM.accentOverlapMs;

export const getButtonDelayMs = (chunkCount: number): number =>
  getAccentFadeStartMs(chunkCount) +
  ONBOARDING_WELCOME_ANIM.accentFadeDurationMs -
  ONBOARDING_WELCOME_ANIM.buttonOverlapMs;

/**
 * Figma accent4 终态纯色
 * @see globals.css `.onboarding-welcome-accent-phrase`
 */
export const ONBOARDING_WELCOME_ACCENT_COLOR =
  "var(--edgen-content_accent4_primary)";
